<span
  pTooltip="{{ tooltipText }}"
  [tooltipPosition]="position"
  [tooltipEvent]="event"
>
  <ng-content></ng-content>
</span>